export function isLandscapeImage (image) {
  return image?.asset?.metadata?.dimensions?.aspectRatio > 1
}

export function getBackgroundColorFromImage (image) {
  return image?.asset?.metadata?.palette?.dominant?.background
}
